import { formatDate } from "@ui-seeker/utils"


export default function dateColumn() {
    return {
        name: "date", label: "Date",
        options: {
            filterOptions: {
                renderValue: v => formatDate(v, {isString: true})
            },
            customFilterListOptions: {
                render: v => `Date: ${formatDate(v, { isString: true })}`
            },
            setCellHeaderProps: () => ({ sx: { textAlign: "center" } }),
            setCellProps: () => ({ sx: { textAlign: "center", minWidth: "130px" } }),
            customBodyRowRenderLite: value => formatDate(value, { isString: true })
        }
    }
}